<template>
  <layout title="Careers">
    <div
      class="
        relative
        px-8
        pt-8
        pb-20
        mx-auto
        xl:px-5
        max-w-3xl
        sm:px-6
        lg:pt-10 lg:pb-28
      "
    >
      <div class="absolute inset-0">
        <div class="h-1/3 sm:h-2/3"></div>
      </div>
      <div class="relative mx-auto max-w-7xl">
        <div class="flex flex-col justify-start">
          <h1
            class="
              text-3xl
              font-extrabold
              leading-9
              tracking-tight
              text-gray-900
              sm:text-4xl sm:leading-10
            "
          >
            Join us
          </h1>
          <p class="mt-3 text-xl leading-7 text-gray-500 sm:mt-4">
            Check out our latest job opportunities.
          </p>
        </div>

        <div
          class="mt-6 max-w-3xl m-auto"
          v-if="jobs != null && jobs.length > 0"
        >
          <div
            class="
              w-full
              relative
              text-center text-lg
              font-bold
              overflow-auto
              whitespace-nowrap
            "
          >
            <div
              class="absolute bottom-0 w-full h-0.5 bg-gray-200"
              style="z-index: -1"
            ></div>
            <span
              class="border-b-2 inline-block p-2 cursor-pointer"
              :class="
                categorieSelected == 'All positions' &&
                'text-primary-color border-primary-color'
              "
              @click="setCategory('All positions', $event)"
              >All positions</span
            >
            <span
              class="border-b-2 inline-block p-2 cursor-pointer"
              :class="
                cat.category == categorieSelected &&
                'text-primary-color border-primary-color'
              "
              v-for="(cat, index) in categories"
              :key="index"
              @click="setCategory(cat.category, $event)"
              >{{ cat.category }}</span
            >
          </div>
          <div class="mt-6">
            <inertia-link
              :href="'careers/' + job.slug"
              v-for="(job, index) in jobs"
              :key="index"
              class="
                px-4
                bg-white
                shadow-allArround
                rounded-r-xl
                border-l-4 border-primary-color
                flex flex-row
                items-center
                justify-between
                mb-4
                group
              "
              style="min-height: 5rem"
            >
              <div
                class="sm:flex sm:space-x-2 text-gray-500 flex-row items-center"
              >
                <span class="text-lg text-gray-800">{{ job.title }}</span>
                <div class="flex space-x-2">
                  <div class="flex">
                    <LocationMarkerIcon class="w-4 mr-1" />
                    <span>{{ job.location }}</span>
                  </div>
                  <div class="flex">
                    <BriefcaseIcon class="w-4 mr-1" />
                    <span>{{ job.contract_type }}</span>
                  </div>
                </div>
              </div>
              <div>
                <font-awesome-icon
                  icon="angle-right"
                  class="group-hover:text-primary-color"
                />
              </div>
            </inertia-link>
          </div>
        </div>
        <p v-else-if="jobs!=null && jobs.length==0" class="mt-10 font-bold text-gray-800">
          We don't have open jobs at the moment. Stay tuned for future job
          positions.
        </p>
      </div>
    </div>
  </layout>
</template>

<script>
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../Components/Layout/layout.vue");

import { LocationMarkerIcon, BriefcaseIcon } from "@vue-hero-icons/outline";

export default {
  components: { layout, LocationMarkerIcon, BriefcaseIcon },
  data() {
    return {
      jobs: null,
      categories: null,
      categorieSelected: "All positions",

    };
  },
  created() {
    this.getJobs("All positions");
  },
  methods: {
    getJobs(category) {
      this.axios
        .get("/api/career-jobs", { params: { categorieSelected: category } })
        .then((response) => {
          this.jobs = response.data.jobs;
          this.categories = response.data.categories;
        });
    },
    setCategory(category, e) {
      this.categorieSelected = category;
      e.target.scrollIntoView({ block: "center", behavior: "smooth" });
      this.getJobs(category);
    },
  },
};
</script>
